import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import NavigationGrid from "./sections/NavigationGrid";
import ComplianceAndAccuracyHeader from "./sections/ComplianceAndAccuracyHeader";
import EquipmentCapabilities from "./sections/EquipmentCapabilities";
import ServiceArea from "./sections/ServiceArea";
import WhyChooseUs from "./sections/WhyChooseUs";
import LeadForm from "./sections/LeadForm";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroSection />
      <NavigationGrid />
      <ComplianceAndAccuracyHeader />
      <EquipmentCapabilities />
      <ServiceArea />
      <WhyChooseUs />
      <LeadForm />
      <Footer />
    </div>;
}